<template>
  <div>
    <b-table
      v-show="showTable"
      responsive
      fixed
      hover
      sticky-header
      :fields="fields"
      :items="processedItems"
      :class="[getTableClass, 'bg-color-row']"
      :filter="searchValue"
      @filtered="handleFiltered"
    >
      <template #head(id)>
        <span>{{ currentCity }}</span>
      </template>

      <template v-slot:cell(products)="row">
        <p v-for="product in row.item.products" :key="product">{{ product }}</p>
      </template>

      <template v-slot:cell(quantities)="row">
        <p
          v-for="(quantity, index) in row.item.quantities"
          :key="`quantity${index}`"
        >
          {{ quantity }}
        </p>
      </template>

      <template v-slot:cell(options)="row">
        <!-- Botão de geração de PDF -->
        <button class="optionsButtonClient mr-3" @click="generatePDF(row.item)">
          <b-icon icon="file-earmark-fill"> </b-icon>
        </button>
        <button
          v-if="!row.item.is_paid && !row.item.is_cancelled"
          class="optionsButtonClient mr-3"
          @click="goToEditClient(row.item)"
        >
          <b-icon icon="pencil-fill"></b-icon>
        </button>
        <button
          v-if="!row.item.is_paid && !row.item.is_cancelled"
          class="optionsButtonClient mr-3"
          @click="deleteClientModal(row.item)"
        >
          <b-icon icon="trash-fill"></b-icon>
        </button>
        <!-- Botão de seleção -->
        <button
          class="optionsButtonClient mr-3"
          @click="handleSubmit(row.item)"
        >
          <!-- Ícone de checkmark -->
          <b-icon
            v-if="!row.item.is_paid && !row.item.is_cancelled"
            icon="check-circle-fill"
            :class="{
              'text-success': row.item.is_paid,
            }"
          ></b-icon>
        </button>
      </template>
    </b-table>
  </div>
</template>

<script>
/* eslint-disable global-require */
/* eslint-disable new-cap */
import JSPDF from 'jspdf';
import 'jspdf-autotable';

import Vue from 'vue';
import { OrderPaid, CancelOrder } from '../../services/Order';
import { Clients } from '../../services/Client';
import showError from '../../utils/showError';
import ModalConfirmPaid from './ModalConfirmPaid.vue';
import MixinSalePDF from '../../utils/MixinSalePDF';
import '../../assets/font/Inter-Bold-normal';
import ModalConfirmationDelete from '../ModalConfirmationDelete.vue';

export default {
  mixins: [MixinSalePDF],
  data() {
    return {
      fields: [
        { key: 'id', class: 'text-left' },
        { key: 'client.name', label: 'Cliente', class: 'text-left' },
        { key: 'deliveryTax', label: 'Taxa de Entrega', class: 'text-center' },
        {
          key: 'deliveryDate',
          label: 'Data de Entrega',
          class: 'text-center',
        },
        {
          key: 'products',
          label: 'Produtos',
          class: 'text-center',
        },
        { key: 'quantities', label: 'Quantidades', class: 'text-center' },
        { key: 'total', label: 'Total', class: 'text-center' },
        { key: 'options', label: 'Ações', class: 'text-center' },
      ],
      isConfirm: true,
      pedido: null,
      showTable: true,
      modalConfirmPaid: null,
      clients: [],
    };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    number: {
      type: Number,
    },
    currentCity: {
      type: String,
      default: '',
    },
    searchValue: {
      type: String,
    },
  },
  watch: {
    items: {
      handler() {
        this.setTableHeaderColor();
      },
      deep: true,
    },
  },
  created() {
    Clients()
      .then((response) => {
        this.clients = response.data;
      })
      .catch(showError);
    this.modalConfirmPaid = new Vue(ModalConfirmPaid);
    this.modalConfirmPaid.$mount();
  },
  computed: {
    processedItems() {
      if (this.items && this.items.length > 0) {
        return this.items.map((item) => {
          const dateParts = item.delivery_date.split('-'); // Divide a data em partes
          const day = dateParts[2];
          const month = dateParts[1];
          const year = dateParts[0].slice(-2); // Pega os últimos dois dígitos do ano
          const deliveryDate = `${day}/${month}/${year}`;
          const deliveryTax = item.delivery_tax.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          });
          const total = item.total_price.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          });
          const products = item.order_products.map(
            (orderProduct) => {
              if (orderProduct.quantity_kg > 0) {
                return `${orderProduct.type} (KG)`;
              }
              if (orderProduct.quantity_unity > 0) {
                return `${orderProduct.type} (UNI)`;
              }
              return `${orderProduct.type} (BDJ)`;
            }
            // `${orderProduct.type} (KG) ${orderProduct.quantity}}`
          );
          const quantities = item.order_products.map(
            (orderProduct) => {
              if (orderProduct.quantity_kg > 0) {
                return `${orderProduct.quantity_kg}`;
              }
              if (orderProduct.quantity_unity > 0) {
                return `${orderProduct.quantity_unity}`;
              }
              return `${orderProduct.quantity_plate}`;
            }
            // `${orderProduct.type} (KG) ${orderProduct.quantity}}`
          );
          return {
            ...item,
            products,
            quantities,
            deliveryDate,
            total,
            deliveryTax,
          };
        });
      }
      return [];
    },
    getTableClass() {
      return `table-${this.number}`; // Utiliza o número para gerar a classe única
    },
  },
  mounted() {
    this.setTableHeaderColor();
  },
  methods: {
    deleteClientModal(pedido) {
      const modalConfirmDelete = new Vue(ModalConfirmationDelete);
      modalConfirmDelete.$mount();
      modalConfirmDelete.$bvModal.show('modal-confirmation-delete');
      modalConfirmDelete.$on('exclusaoConfirmada', () => {
        this.deleteClient(pedido);
      });
    },

    deleteClient(pedido) {
      const data = {
        is_cancelled: true,
      };
      CancelOrder(pedido.id, data)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.$bvModal.hide('modal-confirmation-delete');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(showError);
    },
    handleSubmit(pedido) {
      this.pedido = pedido;
      this.modalConfirmPaid.$bvModal.show('modal-confirm-paid');
      this.modalConfirmPaid.$on('responseModal', this.responseModal);
    },
    handleFiltered(researchedItems) {
      if (researchedItems.length === 0) this.showTable = false;
      else this.showTable = true;
      this.researchedItems = researchedItems;
    },
    setTableHeaderColor() {
      if (this.items && this.items.length > 0) {
        const { color } = this.items[0].client.city;
        const size = this.fields.length;
        const tableClass = `.b-table-sticky-header > .table.b-table > thead > tr > th `;
        const headerThList = document.querySelectorAll(tableClass);
        headerThList.forEach((headerTh, index) => {
          if (index < (this.number + 1) * size && index >= this.number * size)
            headerTh.classList.add(`table-${this.number}`);
        });
        const newTableClass = `th.table-b-table-default.text-center.table-${this.number},
                    th.table-b-table-default.text-left.table-${this.number}
                `;
        const newHeaderThList = document.querySelectorAll(newTableClass);
        newHeaderThList.forEach((headerTh, index) => {
          if (index < (this.number + 1) * size)
            headerTh.style.backgroundColor = color; // eslint-disable-line no-param-reassign
        });
      }
    },
    goToEditClient(pedido) {
      this.$router.push(`/vendas/${pedido.id}`);
    },
    responseModal(event) {
      if (event) {
        const data = {
          is_paid: !this.pedido.is_paid,
        };
        OrderPaid(this.pedido.id, data)
          .then(() => {
            this.modalConfirmPaid.$bvModal.hide('modal-confirm-paid');
            this.$toasted.global.defaultSuccess();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch(showError);
        return;
      }
      this.modalConfirmPaid.$bvModal.hide('modal-confirm-paid');
    },
    async generatePDF(pedido) {
      const doc = new JSPDF();
      const x = 10; // Coordenada X da borda
      let y = 1; // Coordenada Y da borda
      const largura = 190; // Largura da borda
      // Desenhe a borda retangular
      doc.setLineWidth(0.4);
      // Adiciona a logomarca
      let imageUrl = require('../../assets/logo.jpg');
      let response = await fetch(imageUrl);
      let blob = await response.blob();
      let blobUrl = URL.createObjectURL(blob);
      doc.addImage(blobUrl, 'JPEG', x + 4, y + 2, 50, 25);
      URL.revokeObjectURL(blobUrl);
      this.addHeaderPDF(doc, x, y);
      this.addTablePDF(doc, x, y, pedido, this.clients);
      doc.rect(x, y, largura, doc.lastAutoTable.finalY - y);
      const alturaConteudoAtual = doc.lastAutoTable.finalY + 5; // Altura do conteúdo atual considerando um espaço adicional de 5 unidades
      const alturaPaginaA4 = 297; // Altura da página A4 em unidades
      y = alturaConteudoAtual;

      // Verificar se há espaço para duplicar o conteúdo
      const espacoRestante = alturaPaginaA4 - alturaConteudoAtual - 5;

      if (espacoRestante >= alturaConteudoAtual) {
        // Há espaço para duplicar o conteúdo
        // Adicione o conteúdo novamente para duplicar
        // Exemplo:
        doc.setLineWidth(0.4);
        // Adiciona a logomarca
        imageUrl = require('../../assets/logo.jpg');
        response = await fetch(imageUrl);
        blob = await response.blob();
        blobUrl = URL.createObjectURL(blob);
        doc.addImage(blobUrl, 'JPEG', x + 4, y + 2, 50, 25);
        // Libera a URL do Blob
        URL.revokeObjectURL(blobUrl);
        this.addHeaderPDF(doc, x, y);
        this.addTablePDF(doc, x, y, pedido, this.clients);
        doc.rect(x, y, largura, doc.lastAutoTable.finalY - y);
        // Você pode adicionar mais elementos conforme necessário
      } else {
        y = 1;
        doc.addPage();
        doc.setLineWidth(0.4);
        // Adiciona a logomarca
        imageUrl = require('../../assets/logo.jpg');
        response = await fetch(imageUrl);
        blob = await response.blob();
        blobUrl = URL.createObjectURL(blob);
        doc.addImage(blobUrl, 'JPEG', x + 4, y + 2, 50, 25);
        // Libera a URL do Blob
        URL.revokeObjectURL(blobUrl);
        this.addHeaderPDF(doc, x, y);
        this.addTablePDF(doc, x, y, pedido, this.clients);
        doc.rect(x, y, largura, doc.lastAutoTable.finalY - y);
        // Não há espaço suficiente na página para duplicar o conteúdo
      }

      // Salvando ou exibindo o PDF
      doc.save(`recibo_pedido_${pedido.id}.pdf`);
    },
  },
};
</script>

<style>
.b-table {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  /* color: rgb(0, 0, 0); */
}

.bg-color-row {
  background-color: #cecece;
}

.optionsButtonClient {
  background-color: transparent;
  border: none;
  outline: none;
  color: #615f5f;
}

.optionsButtonPDF {
  background-color: transparent;
  border: none;
  outline: none;
  color: #bd4f4f;
}

.optionsButtonClient:focus {
  outline: none;
}

/* Seu arquivo de estilo */
</style>
